module.exports = __webpack_public_path__ + "fonts/iconfont.b78efec.woff2";